import styled from "styled-components";

const CircleButton = styled.button`
  width: 4.8rem;
  height: 4.8rem;
  padding: 0;
  margin: 0;
  border-radius: 2.4rem;
  background-color: rgba(0, 0, 0, 0);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }

  .icon {
    fill: #888;
  }
`;

export default CircleButton;
